import React from "react";
import {useMutation} from "react-query";
import Alert from "react-s-alert";

import {ModalName, useDashboardModalContext} from "./DashboardModalContext";
import {readResidentNameAnswer} from "../../models/AdmissionModel.helpers";
import {useDashboardAdmissionsContext} from "./DashboardAdmissionsContext";
import {CANCELLATION_REASONS} from "../delete-admission-modal/consts";
import {AdmissionsService} from "../../services/AdmissionsService";
import {DeleteAdmissionModal} from "../delete-admission-modal";

export const DashboardDeleteAdmissionModal = () => {
  const {refreshDashboard} = useDashboardAdmissionsContext();
  const {admission, isModalOpened, toggleModal} = useDashboardModalContext(
    ModalName.CANCEL,
  );
  const admissionId = admission?.id;

  const {mutate, isLoading} = useMutation(
    ({admissionId, reason}: {admissionId: string; reason: string}) =>
      AdmissionsService.delete(admissionId, reason),
    {
      onError: () => {
        Alert.error("Failed to delete the Admission.");
      },
      onSuccess: () => {
        Alert.success("Admission was successfully deleted.");
      },
      onSettled: () => {
        toggleModal();
        refreshDashboard();
      },
    },
  );

  return (
    <DeleteAdmissionModal
      admissionCode={admission?.code}
      residentName={admission ? readResidentNameAnswer(admission as any) : ""}
      isOpen={isModalOpened}
      isLoading={isLoading}
      onRequestClose={() => toggleModal()}
      cancellationReasons={CANCELLATION_REASONS}
      onCancel={data =>
        mutate({
          admissionId,
          ...data,
        })
      }
      admissionStatus={admission?.status}
    />
  );
};
